export default {"src":"/_next/static/media/mastercard.1c80df1f.svg","height":27,"width":44,"blurWidth":0,"blurHeight":0};